import React from 'react';

interface TiwazIconProps {
  size?: number;
  className?: string;
}

/**
 * Tiwaz rune (ᛏ), the Elder Futhark rune named for Tyr, drawn as a monochrome
 * stroke-based inline SVG so it inherits `currentColor` and hover/color states,
 * matching the site's other custom icons (TriquetraIcon, TelegramIcon, ...).
 *
 * Geometry (viewBox 0 0 24 24): a single vertical stem rises to a top tip at
 * (12,4); two short arms descend from that same tip down-and-outward to (7,9.5)
 * and (17,9.5), forming the classic upward-pointing rune, not a filled
 * arrowhead. The arms are drawn as one open caret so the tip stays a single,
 * symmetric join. Round caps/joins keep it crisp at small sizes (~18-22px).
 */
export const TiwazIcon: React.FC<TiwazIconProps> = ({ size = 20, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path d="M12 4V20" />
    <path d="M7 9.5L12 4L17 9.5" />
  </svg>
);

export default TiwazIcon;
